export default __webpack_public_path__ + "static/media/1784.ca1e630f.png";